<form class="p-datatable">
    <table class="p-datatable-table">
        <thead role="rowgroup" class="p-datatable-thead">
        <tr>
            <th>{{ 'service.settings.widgetSettings.active' | translate }}</th>
            <th>{{ 'service.settings.widgetSettings.name' | translate }}</th>
            <th>{{ 'service.settings.widgetSettings.dateTo' | translate }}</th>
            <th>{{ 'service.settings.widgetSettings.description' | translate }}</th>
            @if (dashboardSettingsEnabled()) {
                <th>{{ 'service.settings.widgetSettings.allowHide' | translate }}</th>
                <th>{{ 'service.settings.widgetSettings.visibleForGroups' | translate }}</th>
            }
        </tr>
        </thead>
        <tbody role="rowgroup" class="p-element p-datatable-tbody">
            @for (widget of form.widgets; track widget) {
                <tr>
                    <td>
                        <app-check-input
                            [formField]="widget.active"
                            [id]="'widget-active-' + widget.name().value()"
                            label=""
                        ></app-check-input>
                    </td>
                    <td>{{ 'enum.serviceDashboardWidgets.' + widget.name().value() | translate }}</td>
                    <td>
                        @if (serviceWidgetsWithDaysSetting.includes(widget.name().value())) {
                            <app-number-input
                                [formField]="widget.days"
                                [id]="'widget-days-' + widget.name().value()"
                                [min]="0"
                                label=""
                            ></app-number-input>
                        }
                    </td>
                    <td>{{ widget.description().value() }}</td>
                    @if (dashboardSettingsEnabled()) {
                        <td>
                            <app-check-input
                                [formField]="widget.allowHide"
                                [id]="'widget-allow-hide-' + widget.name().value()"
                                label=""
                            ></app-check-input>
                        </td>
                        <td>
                            <app-multi-select-input
                                [formField]="widget.visibleForGroupIds"
                                [id]="'widget-visible-for-groups-' + widget.name().value()"
                                [staticOptions]="groups()"
                                label=""
                                labelKey="name"
                                valueKey="id"
                                filterBy="name"
                                display="comma"
                                [placeholder]="'service.settings.widgetSettings.allGroups' | translate"
                            ></app-multi-select-input>
                        </td>
                    }
                </tr>
            }
        </tbody>
    </table>
</form>
